import { union } from 'io-ts/Decoder';

import { KeepAlive } from './message/type/KeepAlive';
import { Ping } from './message/type/Ping';

export const ClientMessage = union(Ping, KeepAlive);
